var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: _vm.ipagination,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c("span", {}, [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(record)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                          ])
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("platform-config-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }